import '@ant-design/v5-patch-for-react-19';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { initAnalytics } from './lib/analytics';

// Initialize PostHog as early as possible so first-paint pageview is
// captured. No-op when VITE_POSTHOG_KEY is unset (local dev).
initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
